import { Core } from '../core/core';

export function store() {
    return Core.store;
}
